import { put, call, takeLatest } from 'redux-saga/effects';

import { fetchReviewSummary } from '../apis/review';
import {
  getReviewSummaryAction,
  getReviewSummarySuccess,
  getReviewSummaryFailure,
} from '../slices/review';

function* getSummary() {
  try {
    const response = yield call(fetchReviewSummary);
    yield put(getReviewSummarySuccess(response));
  } catch {
    yield put(getReviewSummaryFailure());
  }
}

export default function* reviewSaga() {
  yield takeLatest(getReviewSummaryAction.type, getSummary);
}
